import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiInfo } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { AccessRightEnum } from '../../../../../../../enum/AccessRightEnum';
import { ICampaignSummary } from '../../../../../../../model/measure/IMeasure';
import { IAllStates } from '../../../../../../../store/rootReducer';
import { priceSplitter } from '../../../../../../../utils/helpers/priceSplitter';
import { CampaignGoalEnum } from '../../../../../../../enum/CampaignGoalEnum';
import CardLayout from '../../../../../../../shared/components/card/CardLayout';
import TooltipOverlay from '../../../../../../../shared/components/tooltip/Tooltip';

interface ICampaignSummaryProps {
    campaignSummary?: ICampaignSummary;
}

const awareness = ['touchPoints', 'impressions', 'reach', 'newCpm', 'cpm'];
const engagement = ['engagementRate', 'likes', 'comments', 'engagements'];
const conversions = ['clicks', 'cpc', 'conversionRate'];

export const CampaignSummaryTouchpoints = ({ campaignSummary }: ICampaignSummaryProps) => {
    const { t } = useTranslation();
    const { accessRights } = useSelector((state: IAllStates) => state.auth.user);
    const { campaign } = useSelector((state: IAllStates) => state.selectedCampaign);
    const hideCosts = accessRights.includes(AccessRightEnum.MEASURE_HIDE_COSTS);

    return (
        <div className="row">
            <div className="col-md-4 mb-3 mb-md-0">
                <CardLayout
                    classCard={`h-100 ${
                        campaign?.campaignGoal?.title === CampaignGoalEnum.AWARENESS && 'border-primary'
                    }`}
                >
                    <h6>{CampaignGoalEnum.AWARENESS}</h6>
                    <div className="row mt-3" style={{ rowGap: '8px' }}>
                        {awareness?.map(item => {
                            if ((item === 'newCpm' || item === 'cpm') && hideCosts) return '';
                            return (
                                <div className="col-6" key={item}>
                                    <h4
                                        className={`text-primary mb-0 ${
                                            item === 'newCpm' || item === 'cpm' ? 'euro-symbol' : ''
                                        }`}
                                    >
                                        {campaignSummary?.[item as keyof ICampaignSummary]
                                            ? priceSplitter(campaignSummary?.[item as keyof ICampaignSummary] ?? 0)
                                            : 'n.a.'}
                                    </h4>
                                    <div className="d-flex align-items-center">
                                        {t(`brand.campaign.measure.${item}`)}
                                        <TooltipOverlay
                                            className="ms-1"
                                            content={t(`brand.campaign.measure.${item}Tooltip`)}
                                        >
                                            <FiInfo size={14} />
                                        </TooltipOverlay>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </CardLayout>
            </div>
            <div className="col-md-4 mb-3 mb-md-0">
                <CardLayout
                    classCard={`h-100 ${
                        campaign?.campaignGoal?.title === CampaignGoalEnum.ENGAGEMENT && 'border-primary'
                    }`}
                >
                    <h6>{CampaignGoalEnum.ENGAGEMENT}</h6>
                    <div className="row mt-3" style={{ rowGap: '8px' }}>
                        {engagement?.map(item => (
                            <div className="col-6" key={item}>
                                <h4 className="text-primary mb-0">
                                    {campaignSummary?.[item as keyof ICampaignSummary]
                                        ? priceSplitter(campaignSummary?.[item as keyof ICampaignSummary] ?? 0)
                                        : 'n.a.'}
                                    {item === 'engagementRate' ? ' %' : ''}
                                </h4>
                                <div className="d-flex align-items-center">
                                    {t(`brand.campaign.measure.${item}`)}
                                    <TooltipOverlay
                                        className="ms-1"
                                        content={t(`brand.campaign.measure.${item}Tooltip`)}
                                    >
                                        <FiInfo size={14} />
                                    </TooltipOverlay>
                                </div>
                            </div>
                        ))}
                    </div>
                </CardLayout>
            </div>
            <div className="col-md-4">
                <CardLayout
                    classCard={`h-100 ${
                        campaign?.campaignGoal?.title === CampaignGoalEnum.CONVERSIONS && 'border-primary'
                    }`}
                >
                    <h6>{CampaignGoalEnum.CONVERSIONS}</h6>
                    <div className="row mt-3" style={{ rowGap: '8px' }}>
                        {conversions?.map(item => {
                            if (item === 'cpc' && hideCosts) return '';
                            return (
                                <div className="col-6" key={item}>
                                    <h4 className={`text-primary mb-0 ${item === 'cpc' ? 'euro-symbol' : ''}`}>
                                        {campaignSummary?.[item as keyof ICampaignSummary]
                                            ? priceSplitter(campaignSummary?.[item as keyof ICampaignSummary] ?? 0)
                                            : 'n.a.'}
                                        {item === 'conversionRate' ? ' %' : ''}
                                    </h4>
                                    <div className="d-flex align-items-center">
                                        {t(`brand.campaign.measure.${item}`)}
                                        <TooltipOverlay
                                            className="ms-1"
                                            content={t(`brand.campaign.measure.${item}Tooltip`)}
                                        >
                                            <FiInfo size={14} />
                                        </TooltipOverlay>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </CardLayout>
            </div>
        </div>
    );
};
